// extracted by mini-css-extract-plugin
export default {"modalLoaderIcon":"t3vvD7z2xCXVeDxAfZOP"};